const { VUE_APP_HOST, VUE_APP_ENVKEY } = process.env;
const MODE = {
	dev: {
		env: 'dev',
		host: 'https://dev.tuwenzhibo.com',
		surveyHost: 'https://dev.tuwenzhibo.com',
		ssoPath: 'https://logindev.ourwill.cn',
		apipath: '/srv',
		surveyApipath: '/shop/api',
		uploadsever: '/upload/one',
		apiPath: 'https://dev.tuwenzhibo.com',
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
		apiHost: 'https://m-dev.inmuu.com',
		bindLink: 'https://logindev.ourwill.cn/bindByUnionId?service=',
	},
	beta: {
		env: 'beta',
		host: location.origin,
		surveyHost: location.origin,
		ssoPath: 'https://logindev.ourwill.cn',
		apipath: '/srv',
		surveyApipath: '/shop/api',
		uploadsever: '/upload/one',
		apiPath: location.origin,
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
		apiHost: 'https://m-beta.inmuu.com',
		bindLink: 'https://logindev.ourwill.cn/bindByUnionId?service=',
	},
	release: {
		env: 'release',
		host: location.origin,
		surveyHost: location.origin,
		ssoPath: 'https://sso.inmuu.com',
		apipath: '/srv',
		surveyApipath: '/shop/api',
		uploadsever: '/upload/one',
		apiPath: location.origin,
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
		apiHost: 'https://m.inmuu.com/v1',
		bindLink: 'https://sso.inmuu.com/bindByUnionId?service=',
	},
	business_beta: {
		env: 'business',
		host: 'http://saas.inmuu.com',
		surveyHost: 'http://saas.inmuu.com/beta',
		ssoPath: 'https://sso.inmuu.com',
		surveyApipath: '/beta/srv',
		apipath: '/beta/srv',
		uploadsever: '/api/fileStorage/one',
		apiPath: 'http://saas.inmuu.com',
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
		apiHost: 'https://m.inmuu.com',
	},
	business_v1: {
		env: 'business',
		host: location.origin,
		surveyHost: location.origin + '/v1',
		ssoPath: 'https://sso.inmuu.com',
		surveyApipath: '/v1/srv',
		apipath: '/v1/srv',
		uploadsever: '/api/fileStorage/one',
		apiPath: location.origin,
		Host: VUE_APP_HOST,
		uploadHost: 'https://upload.inmuu.com/' + VUE_APP_ENVKEY,
		apiHost: 'https://m.inmuu.com',
	},
};

const conf = MODE[process.env.VUE_APP_ENV];

if (process.env.NODE_ENV == 'development') {
	conf._host = `${conf.host}`;
	conf.host = `/remote-${conf.env}`;
	conf.apiPath = `/remote-${conf.env}`;
}

conf.ssrUrl = 'https://ssr.ourwill.cn';

export const wxAppInfo = {
	suiteId: 'wwf12649e73464e832',
	appid: 'wx812fc1264e1e290a',
	scope: 'snsapi_userinfo',
	srvcode: `${conf.apiHost}/srv/wechat-auth/check-code`,
	micreAppid: 'wx841bf46ddf45ae54',
	component_appid: 'wxc52740f5e28cec11',
	redirect_uri: `${conf.apiHost}/srv/wechat-auth/check-code`,
	tp_redirect_uri: `${conf.apiHost}/srv/wechat-auth/wxtp/check-code`,
};

export default conf;
